import { BookingStatusEnum } from "src/app/shared/models/booking-status.enum";
import { BookingBase } from "./booking-base";

export class BookingList extends BookingBase{
    startTime: Date;
    endTime: Date;
    status: BookingStatusEnum;
    simulatorId: string;
    bayName: string;
    bayNumber: string;
    confirmationNumber: string;
    participants: number;
    totalPrice: number;
    priceOverride: number;
    priceOverrideReason: string;
    hasPaid: boolean;
    phoneNumber: string;
    email: string;
    customerName: string;
    refundAmount: number;
    refundReason: string;
    digitalWaiverEntryId: string;
    stripePaymentIntentId: string;
}